// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.job-select select {
  background-color: var(--mittelgruen);
  border: none;
  padding: 10px 40px 10px 10px;
  border-radius: 10px;
  width: 100%;
  color: #9fb05f;
  margin-bottom: 15px;
  font-family: 'Circular', sans-serif;
  text-transform: none;
}

.job-form input[type="text"],
.job-form textarea {
  background-color: var(--mittelgruen);
  border: none;
  padding: 10px;
  border-radius: 5px;
  width: 100%;
  color: var(--dunkelgruen);
  margin-bottom: 15px;
  font-size: 1em;
}

/* selected option style */

.dropdown-wrapper.filled select {
  color: var(--dunkelgruen);
  font-weight: normal;
}


.job-select h3 {
  color: var(--dunkelgruen);
}


.job-select select option[disabled] {
  color: #9fb05f;
}

/* Center content similar to other pages */

.job-form {
  text-align: left;
}

.job-select {
  margin-bottom: 1rem;
  text-align: left;
}

.actions {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.jb-map-container {
  margin-bottom: 1rem;
}

.jb-map-link {
  display: flex;
  align-items: center;
  gap: 0.3rem;
}

.jb-map-label {
  color: var(--dunkelgruen);
  font-size: 1em;
  text-decoration: underline;
  text-underline-offset: 4px;
}

.jb-map-icon {
  font-size: 1.2rem;
  color: var(--dunkelgruen);
}

.delete-link {
  display: flex;
  align-items: center;
  gap: 0.2rem;
  cursor: pointer;
  margin-left: 0.5rem;
}

.delete-label {
  color: var(--blutorange);
  font-size: 1.2rem;
  text-decoration: underline;
  text-underline-offset: 4px;
}

.delete-icon {
  font-size: 1.2rem;
  color: var(--blutorange);
  margin-left: 0.2rem;
}
`, "",{"version":3,"sources":["webpack://./src/arbeit/jobsverwaltung/JobBearbeiten.css"],"names":[],"mappings":"AAAA;EACE,oCAAoC;EACpC,YAAY;EACZ,4BAA4B;EAC5B,mBAAmB;EACnB,WAAW;EACX,cAAc;EACd,mBAAmB;EACnB,mCAAmC;EACnC,oBAAoB;AACtB;;AAEA;;EAEE,oCAAoC;EACpC,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;AAChB;;AAEA,0BAA0B;;AAE1B;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;;AAGA;EACE,yBAAyB;AAC3B;;;AAGA;EACE,cAAc;AAChB;;AAEA,0CAA0C;;AAE1C;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,iBAAiB;EACjB,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;EACxB,mBAAmB;AACrB","sourcesContent":[".job-select select {\n  background-color: var(--mittelgruen);\n  border: none;\n  padding: 10px 40px 10px 10px;\n  border-radius: 10px;\n  width: 100%;\n  color: #9fb05f;\n  margin-bottom: 15px;\n  font-family: 'Circular', sans-serif;\n  text-transform: none;\n}\n\n.job-form input[type=\"text\"],\n.job-form textarea {\n  background-color: var(--mittelgruen);\n  border: none;\n  padding: 10px;\n  border-radius: 5px;\n  width: 100%;\n  color: var(--dunkelgruen);\n  margin-bottom: 15px;\n  font-size: 1em;\n}\n\n/* selected option style */\n\n.dropdown-wrapper.filled select {\n  color: var(--dunkelgruen);\n  font-weight: normal;\n}\n\n\n.job-select h3 {\n  color: var(--dunkelgruen);\n}\n\n\n.job-select select option[disabled] {\n  color: #9fb05f;\n}\n\n/* Center content similar to other pages */\n\n.job-form {\n  text-align: left;\n}\n\n.job-select {\n  margin-bottom: 1rem;\n  text-align: left;\n}\n\n.actions {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.jb-map-container {\n  margin-bottom: 1rem;\n}\n\n.jb-map-link {\n  display: flex;\n  align-items: center;\n  gap: 0.3rem;\n}\n\n.jb-map-label {\n  color: var(--dunkelgruen);\n  font-size: 1em;\n  text-decoration: underline;\n  text-underline-offset: 4px;\n}\n\n.jb-map-icon {\n  font-size: 1.2rem;\n  color: var(--dunkelgruen);\n}\n\n.delete-link {\n  display: flex;\n  align-items: center;\n  gap: 0.2rem;\n  cursor: pointer;\n  margin-left: 0.5rem;\n}\n\n.delete-label {\n  color: var(--blutorange);\n  font-size: 1.2rem;\n  text-decoration: underline;\n  text-underline-offset: 4px;\n}\n\n.delete-icon {\n  font-size: 1.2rem;\n  color: var(--blutorange);\n  margin-left: 0.2rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
